import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgArrowDropDownFilled = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m17.35 10.298-4.826 4.472A.7.7 0 0 1 12 15a.77.77 0 0 1-.524-.205l-4.825-4.498a.745.745 0 0 1-.03-1.063.77.77 0 0 1 1.078-.028L12 13.217l4.302-4.013a.77.77 0 0 1 1.077.03.75.75 0 0 1-.03 1.064"
    }));
export default SvgArrowDropDownFilled;
